export default __webpack_public_path__ + "static/media/help_main-photo_ok.f24afe2e.jpg";